module.exports = __webpack_public_path__ + "static/media/2.3_preview.de89355c.png";